import { ArrayValidator, ArrayValidTypes } from './types-validators/array-validator';
import { EnumFilter, StringEnum } from './filters/enum-filter';
import { RangeFilter } from './filters/range-filter';
import { BooleanValidator } from './types-validators/boolean-validator';
import { FloatValidator } from './types-validators/float-validator';
import { IntegerValidator } from './types-validators/integer-validator';
import { PhoneNumberValidator } from './types-validators/phone-number-validator';
import { StringValidator } from './types-validators/string-validator';

export const dv = {
    boolean: () => new BooleanValidator(),
    enum: (enumerator: StringEnum) => new StringValidator().enum(enumerator),
    float: () => new FloatValidator(),
    integer: () => new IntegerValidator(),
    phoneNumber: (selectedRegionCodeFieldName: string) =>
        new PhoneNumberValidator(selectedRegionCodeFieldName),
    string: () => new StringValidator(),
    array: (validator: ArrayValidTypes) => new ArrayValidator(validator),
    uuid: () =>
        new StringValidator().format(
            /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
        ),
    filters: {
        enum: (enumerator: StringEnum) => new EnumFilter(enumerator),
        range: (minValue: number, maxValue: number) => new RangeFilter(minValue, maxValue),
    },
};
